import React, { useEffect, useState } from 'react';
// import AllTransactionTable from '../components/AllTransactionTable';
// import Main from '../components/layout/Main';
import axios from 'axios';
import {  message,Select, Popover, Tag } from 'antd';
import { format } from 'date-fns';
import { FaCheckCircle } from 'react-icons/fa';
import { MdCancel } from 'react-icons/md';
import AllTransactionTable from '../Component/AllTransaction';


const { Option } = Select;

function BotTransaction() {
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(50);
    const [data, setData] = useState([]);
    const [statusFilterValue, setStatusFilterValue] = useState("PENDING");
    const [dateFilter, setdateFilter] = useState(null);
    const [UsernameFilter, setUsernameFilter] = useState(null);
    const [TransidFilter, setTransidFilter] = useState(null);

const [apitype, setapitype] = useState("LIVE")
const [exchangetype, setexchangetype] = useState("FUTURES")
const [exchange, setexchange] = useState("BINANCE")


    const handleStatusFilter = (status) => {
        setStatusFilterValue(status);
    };


    const handleApitype = (apitype) => {
        setapitype(apitype);
    };

    const handleexchangetype = (exchange_type) => {
        setexchangetype(exchange_type);
    };

    const handleexchange = (exchange) => {
        setexchange(exchange);
    };



    const ViewTotalLevel = (statusFilterValue, usernameValue, adminValue, datefilter) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
        };

        if (statusFilterValue !== null && statusFilterValue !== undefined) {
            postData.approved = [statusFilterValue];
        }
        if (Array.isArray(datefilter) && datefilter.length > 0) {
            postData.date = datefilter;
        }
              
        if (usernameValue !== null && usernameValue !== undefined) {
            if (/^\d+$/.test(usernameValue)) {
                postData.transid = [usernameValue];
            } else {
                postData.username = [usernameValue];
            }
        }

        if (adminValue !== null && adminValue !== undefined) {
            postData.adminname = [adminValue];
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/bot/total_page_view_apis',
            data: postData
        }).then(res => {
            setTotalPages(res?.data?.Success);
        }).catch(err => {
            console.log(err);
        });
    };

    const ViewLevel = (statusFilterValue, usernameValue, adminValue, datefilter,apitype,exchangetype,exchange) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
        };

        if (statusFilterValue !== null && statusFilterValue !== undefined) {
            postData.approved = [statusFilterValue];
        }

        if (apitype !== null && apitype !== undefined) {
            postData.api_type = [apitype];
        }

        if (exchangetype !== null && exchangetype !== undefined) {
            postData.exchange_type = [exchangetype];
        }

        if (exchange !== null && exchange !== undefined) {
            postData.exchange = [exchange];
        }

        if (Array.isArray(datefilter) && datefilter.length > 0) {
            postData.date = datefilter;
        }
             
        if (usernameValue !== null && usernameValue !== undefined) {
            if (/^\d+$/.test(usernameValue)) {
                postData.transid = [usernameValue];
            } else {
                postData.username = [usernameValue];
            }
        }

        if (adminValue !== null && adminValue !== undefined) {
            postData.adminname = [adminValue];
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/bot/view_apis',
            data: postData
        }).then(res => {
            if (res?.data?.Success === "No transactions yet!") {
                setData([]);
                // message.info("No transactions yet!");
            } else {
                setData(res?.data?.Success);
            }
        }).catch(err => {
            message.error(err);
        });
    };

    useEffect(() => {
        ViewTotalLevel(statusFilterValue, UsernameFilter, TransidFilter, dateFilter,apitype,exchangetype,exchange);
        ViewLevel(statusFilterValue, UsernameFilter, TransidFilter, dateFilter,apitype,exchangetype,exchange);
    }, [page, size, dateFilter, statusFilterValue, TransidFilter, UsernameFilter,apitype,exchangetype,exchange]);

    // useEffect(() => {
    //     if (statusFilterValue !== null) {
    //         ViewTotalLevel(statusFilterValue);
    //         ViewLevel(statusFilterValue);
    //     }
    // }, [statusFilterValue]);


    const [popoverVisible, setPopoverVisible] = useState(false);


    const columns = [
        {
            title: 'Sr.No',
            dataIndex: 'Serial',
            key: 'Serial',
        },
        {
            title: 'Date & Time',
            dataIndex: 'Created_At',
            key: 'Created_At',
        },
        {
            title: 'Username',
            dataIndex: 'Username',
            key: 'Username',
        },
        {
            title: 'API ID',
            dataIndex: 'API_ID',
            key: 'API_ID',
        },
        {
            title: 'API Name',
            dataIndex: 'API_Name',
            key: 'API_Name',
        },
        {
            title: 'Exchange Type',
            dataIndex: 'Exchange_Type',
            key: 'Exchange_Type',
        },
        {
            title: 'Exchange',
            dataIndex: 'Exchange',
            key: 'Exchange',
        },
        {
            title: 'Type',
            dataIndex: 'Trade_Type',
            key: 'Trade_Type',
            render: (text) => {
                return text === "LIVE" ? <Tag color="green">{text}</Tag> : <Tag color="red">{text}</Tag>
            }
        },
        {
            title: 'Status',
            dataIndex: 'Approved',
            key: 'Approved',
            render: (text, record) => {
                const getStatusClass = () => {
                    if (text === 'PENDING') return 'text-orange-500'; // Orange for pending
                    if (text === 'APPROVED') return 'text-green-500'; // Green for approved
                    if (text === 'REJECTED') return 'text-red-500'; // Red for rejected
                    return ''; // Default for unexpected values
                };
                if (text === 'PENDING') {
                    return (
                        <Popover
                            content={
                                <div className="flex gap-5 items-center">
                                    <button onClick={() => handleStatusChange(record.API_ID, true)} className="flex items-center flex-col text-black animate-pulse">
                                        <FaCheckCircle size={35} className='text-[green]' />
                                        <span>Approve</span>
                                    </button>
                                    <button onClick={() => handleStatusChange(record.API_ID, false)} className="flex items-center flex-col text-black animate-pulse">
                                        <MdCancel size={35} className='text-[red]' />
                                        <span>Reject</span>
                                    </button>
                                </div>
                            }
                            trigger="click"
                        >
                            <button className='text-colorSecondaryDark font-bold border border-colorSecondaryDark px-2 py-1 rounded-lg text-xs bg-colorSecondaryDark/20 hover:bg-white '>{text}</button>
                        </Popover>
                    );
                } else {
                    return <span className={`font-bold ${getStatusClass()}`}>{text}</span>;
                }
            },
        },
    ];
    const handleStatusChange = (API_ID, approved) => {
        const jwt = localStorage.getItem('jwt');
        const postData = {
            jwt: jwt,
            apiid: API_ID,
            approved: approved
        };
        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: `${process.env.REACT_APP_API}/bot/change_api_status`,
            data: postData
        }).then(response => {
            setPopoverVisible(false);
            message.success(response?.data?.Success);
            ViewLevel(statusFilterValue, UsernameFilter, TransidFilter, dateFilter);
        }).catch(err => {
            message.error(err?.response?.data?.Error);
            setPopoverVisible(false);
        });
    };

    const dataSource = Array.isArray(data) ? data?.map((item, index) => ({
        Serial: index + 1,
        Created_At: item?.Created_At || "--",
        API_Name: item?.API_Name || "--",
        Username: item?.Username || "--",
        Exchange_Type: item?.Exchange_Type || "--",
        Exchange: item?.Exchange || "--",
        Trade_Type: item?.Trade_Type || "--",
        API_ID: item?.API_ID || "--",
        Balance: item?.Balance || "--",
        Key: item?.Key || "--",
        Approved: item?.Approved || "--",
    })) : [];


    const handleSearch = (value) => {
        const searchValues = value.split(',').map(item => item.trim());
        const usernameValue = searchValues[0] || null;
        const transidValue = searchValues[1] || null;

        if ((usernameValue && transidValue) || (!usernameValue && !transidValue)) {
            console.log('Invalid input');
            return;
        }

        if (transidValue) {
            ViewTotalLevel(statusFilterValue, null, transidValue, dateFilter);
            ViewLevel(statusFilterValue, null, transidValue, dateFilter);
        } else {
            ViewTotalLevel(statusFilterValue, usernameValue, null, dateFilter);
            ViewLevel(statusFilterValue, usernameValue, null, dateFilter);
        }
    };

    const prepareDataForCSV = () => {
        const csvData = Array.isArray(data) ? data?.map((item, index) => ({
            Serial: index + 1,
            Created_At: item?.Created_At || "--",
            API_Name: item?.API_Name || "--",
            Username: item?.Username || "--",
            Exchange_Type: item?.Exchange_Type || "--",
            Exchange: item?.Exchange || "--",
            Trade_Type: item?.Trade_Type || "--",
            API_ID: item?.API_ID || "--",
            Approved: item?.Approved || "--",
        })) : [];

        return csvData;
    };
    const handleDateChange = (dates, dateStrings) => {
        if (dates && dates[0] && dates[1]) {
            const formattedDates = dates.map(date => date.toDate()).map(date => format(date, 'dd-MM-yyyy'));
            setdateFilter(formattedDates);
        } else {
            setdateFilter(null);
        }
    };

    const shownKeys = ['Serial', 'DateTime', 'Trans_ID', 'Adminname', 'Username', 'Action'];

    return (
        <>
            {/* <Main> */}
                <div className='mx-4 bg-white shadow-md shadow-black rounded-xl p-4 '>

                <div className="my-4 flex lg:flex-row flex-col justify-between ">
            {/* Status Filter */}
            <div className='col-span-3 lg:col-span-2 my-2'>
                <button
                    onClick={() => handleStatusFilter('PENDING')}
                    className={`text-colorSecondaryDark border px-2 md:px-4 text-[10px] md:text-base py-1 rounded-lg border-colorSecondaryDark ${statusFilterValue === 'PENDING' ? 'font-bold bg-colorSecondaryDark text-white px-4 py-2' : ''}`}
                >
                    PENDING
                </button>
                <button
                    onClick={() => handleStatusFilter('APPROVED')}
                    className={`mx-2 lg:mx-10 text-colorSecondaryDark border px-2 md:px-4 text-[10px] md:text-base py-1 rounded-lg border-colorSecondaryDark ${statusFilterValue === 'APPROVED' ? 'font-bold bg-colorSecondaryDark text-white px-4 py-2' : ''}`}
                >
                    APPROVED
                </button>
                <button
                    onClick={() => handleStatusFilter('REJECTED')}
                    className={`text-colorSecondaryDark border px-2 md:px-4 text-[10px] md:text-base py-1 rounded-lg border-colorSecondaryDark ${statusFilterValue === 'REJECTED' ? 'font-bold bg-colorSecondaryDark text-white px-4 py-2' : ''}`}
                >
                    REJECTED
                </button>
            </div>

            {/* API Type Filter (Select Dropdown) */}
            <div className='my-2 flex items-center'>
                <label htmlFor="apitype" className="block  text-sm text-colorSecondaryDark">API Type :- </label>
                <Select
                    id="apitype"
                    value={apitype}
                    onChange={handleApitype}
                    className="w-full lg:w-40"
                    >
                    <Option value="LIVE">LIVE</Option>
                    <Option value="PAPER">PAPER</Option>
                </Select>
            </div>

            {/* Exchange Type Filter (Select Dropdown) */}
            <div className='my-2 flex items-center'>
                <label htmlFor="exchangetype" className="block  text-sm text-colorSecondaryDark">Exchange Type :- </label>
                <Select
                    id="exchangetype"
                    value={exchangetype}
                    onChange={handleexchangetype}
                    className="w-full lg:w-40"
                    >
                    <Option value="FUTURES">FUTURES</Option>
                    <Option value="SPOT">SPOT</Option>
                </Select>
            </div>

            {/* Exchange Filter (Select Dropdown) */}
            <div className='my-2 flex items-center'>
                <label htmlFor="exchange" className="block  text-sm text-colorSecondaryDark">Exchange :- </label>
                <Select
                    id="exchange"
                    value={exchange}
                    onChange={handleexchange}
                    className='text-colorSecondaryDark'
                >
                    <Option value="BINANCE">BINANCE</Option>
                    <Option value="KUCOIN">KUCOIN</Option>
                </Select>
            </div>
        </div>


                    {/* <div className='mx-4 bg-white shadow-md shadow-black rounded-xl p-4 '> */}
                        <AllTransactionTable data={data} handleDateChange={handleDateChange} handleSearch={handleSearch} prepareDataForCSV={prepareDataForCSV} onSearch={handleSearch} setData={setData} columns={columns} dataSource={dataSource} totalPages={totalPages} page={page} size={size} setPage={setPage} setSize={setSize} />
                    {/* </div> */}
                </div>
            {/* </Main> */}
        </>
    );
}

export default BotTransaction;
